export default __webpack_public_path__ + "static/media/triangledown.178ce355.svg";